var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendbuttonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#005068"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2833 25.4778L28.2792 18.6211C29.0217 18.3003 29.0217 17.2553 28.2792 16.9345L12.2833 10.0778C11.6783 9.81197 11.0092 10.2611 11.0092 10.912L11 15.1378C11 15.5961 11.3392 15.9903 11.7975 16.0453L24.75 17.7778L11.7975 19.5011C11.3392 19.5653 11 19.9595 11 20.4178L11.0092 24.6436C11.0092 25.2945 11.6783 25.7436 12.2833 25.4778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendbuttonicon);
export default __webpack_public_path__ + "static/media/sendbuttonicon.8999f9eabcfde6d42224cbec38c48f52.svg";
export { ForwardRef as ReactComponent };